import { ConsolidatedLocationView, SubPremiseDto } from '@mark43/cad-api';

export function getSubPremiseDtosFromLocation(
    location: ConsolidatedLocationView | null
): SubPremiseDto[] {
    const subPremises: SubPremiseDto[] = [];
    if (location) {
        for (let i = 1; i < 6; i++) {
            const subPremiseName = location[
                `subPremise${i}Name` as keyof ConsolidatedLocationView
            ] as string;
            const subPremiseValue = location[
                `subPremise${i}Value` as keyof ConsolidatedLocationView
            ] as string;
            if (subPremiseName || subPremiseValue) {
                subPremises.push({
                    subPremiseValue,
                    subPremiseName,
                });
            }
        }
    }
    return subPremises;
}
